import React, {  } from 'react';
import { useSelector } from 'react-redux';
import { getShkolaFromRoles } from '../../../common/Tool';
import SeriiBlock from '../../components/SeriiBlock'
import PageLayout from '../../components/PageLayout';
import { GET, errorCatch, useAuth } from 'fennec-ui';
import { useSchoolContext } from '../../../common/Context';

export default function SchoolEventsSerii(props) {
    const [school, setSchool] = useSchoolContext();
    // const shkola = useSelector(getShkolaFromRoles(["ВладелецШколыФедерации", "АдминистраторШколыФедерации"], true));
    // const auth = useAuth()
    // const [shkola, setShkola] = React.useState([])
    // React.useEffect(()=>{
    //     GET(auth, '/api/school/list-by-admin', ({data})=>{
    //         setShkola(data);
    //     }, errorCatch)
    // }, [])

    // const context = React.useMemo(() => ({
    //     collection: shkola,
    //     title: "Школа",
    //     name: (item) => item.nazvanieShkoliTantsev,
    //     mix: (item) => {
    //         return {
    //             // organizatorFederatsiyaID: 1, // Организатор федерация
    //             organizatorShkolaID: item.ID, // Организатор школа
    //             // organizatorMeropriyatiyaID: item.ID, // Организатор мероприятия
    //             // organizatorRegionalnoeOtdelenieID: item.ID // Организатор региональное отделение
    //         }
    //     }
    // }), [shkola])

    return (<PageLayout>
        {school && <SeriiBlock auth={props.auth} source={"/api/serii/list/school"}
            base="school"
            sourceKey="school"
            create={true}
            ctx={{organizatorShkolaID: school?.ID}}
        />}
        </PageLayout>
    );
}
